export function isEmpty(value: unknown): boolean {
  // Handle null or undefined
  if (value === null || value === undefined) {
    return true
  }

  // Handle arrays
  if (Array.isArray(value)) {
    return value.length === 0
  }

  // Handle strings
  if (typeof value === 'string') {
    return value.length === 0
  }

  // Handle objects (check for own enumerable properties)
  if (typeof value === 'object') {
    return Object.keys(value as object).length === 0
  }

  // Non-collection types (numbers, booleans, functions, etc.) are not empty
  return false
}
